import { Component, signal, output, input, OnInit } from '@angular/core';
import { form, submit, required, email, maxLength, FormField } from '@angular/forms/signals';

export interface GuestFormData {
  email: string;
  fullName: string;
}

@Component({
  selector: 'mai-guest-disclaimer-form',
  imports: [FormField],
  templateUrl: './guest-disclaimer-form.html',
})
export class GuestDisclaimerForm implements OnInit {
  readonly formData = input<GuestFormData>();
  readonly loading = signal(false);
  readonly formSubmitted = output<GuestFormData>();

  readonly guestModel = signal<GuestFormData>({
    email: '',
    fullName: '',
  });

  ngOnInit() {
    const guestData = this.formData();
    if (guestData) {
      this.guestModel.set(guestData);
    }
  }

  readonly guestForm = form(this.guestModel, (schema) => [
    required(schema.email, { message: 'Email is required' }),
    email(schema.email, { message: 'Please enter a valid email address' }),
    required(schema.fullName, { message: 'Name is required' }),
    maxLength(schema.fullName, 50, { message: 'Name must not exceed 50 characters' }),
  ]);

  /**
   * Submit the form (called by parent component)
   * The form data will be emitted to the parent for processing
   */
  submitForm(): void {
    submit(this.guestForm, async () => {
      this.loading.set(true);
      const formData = this.guestModel();
      this.formSubmitted.emit(formData);
    });
  }
}
